 import {
   Axios
 } from '@/utils/from-common';

 // 搜索记录
 export const Search_List = (param) => Axios('POST', '/bms/search/SearchList', param);